import { HeroV2Section } from "@/templates/enterprise/enterprise-landing-page/sections";

/*
Currently this is used to get a React compoent to unblock the Enterprise pages DXP launch
It will evolve into a new Design System concept as a configurable Hero Carousel 
*/
const UniformHeroCarousel = () => {
    return <HeroV2Section />;
};

export default UniformHeroCarousel;
